import { z } from 'zod';

export const createEntrySchema = z
  .object({
    fieldChanges: z
      .array(
        z.object({
          fieldId: z.string().min(1),
          value: z
            .unknown()
            .refine((value) => value !== undefined, { message: 'value is required' })
        })
      )
      .optional()
  })
  .optional();
